
export function validateTwinUrl(twinUrl) {
  try {

    let [schema, rest] = twinUrl.split("https://");
    if (schema || schema.length != 0) {
      return { error: "Must start with https://" };
    }
    let [sub, domain] = rest.split(/\.biz(?:-staging)?\.todaq\.net/);
    if (domain != "") {
      return { error: "Must end with .biz.todaq.net" };
    }
    let [addr, acc] = sub.split(".");
    if (!acc || acc.length == 0) {
      return { error: "Must have account slug"}
    }
    if (addr.length != 32) {
      return { error: "Address must be 32 characters long" };
    }
    let hexMatch = addr.match(/^[0-9a-f]+$/i)[0];
    if (hexMatch != addr) {
      return { error: "Address must string must be hex" };
    }

    return null;
  } catch (e) {
    console.error(e)
    return { error: "error", data: e };
  }
}
